import PeriodDateField from '@UI/Pages/Administration/AiCosts/Filters/PeriodDateField';
import * as React from 'react';

/** The two bounds of the period, each in its own labelled date field. */
const PeriodFilter: React.FC = () => {
	return (
		<React.Fragment>
			<PeriodDateField edge="from" />
			<PeriodDateField edge="to" />
		</React.Fragment>
	);
};

export default PeriodFilter;
